<script>
    import { TOKEN_SESSION, USER, TOAST_MESSAGE } from "../../stores";
    import { onMount } from "svelte";
    import Bars from "../Charts/Bars.svelte";
    import Pie from "../Charts/Pie.svelte";
    import GLOBALS from "../../globals/GLOBALS";

    export let rep_usu_id
    let dataRows = null
    let datos
    let labels
    let titleData

    onMount(() => {
        _REP_QUERY("ALLFAVORITES",{rep_usu_id})
    })

    const _REP_QUERY = async (QUERY, data) => {
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/reportes/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    switch (QUERY) {
                        case "ALLFAVORITES":
                            dataRows = new Array()
                            json.rows.forEach(rowItem => {
                                datos = new Array()
                                labels = new Array()
                                titleData = new Array()
                                //construye el dataset para el grafico: Es un array para mostrar mas de 1 en Bars
                                rowItem.rows.forEach((item, index) => {
                                    rowItem.fields.filter(e => e.name !== "name").forEach( (field,idx) => {
                                        if (index === 0) datos.push(new Array())
                                        datos[idx].push(item[field.name])
                                        titleData.push(field.name)
                                    })
                                })   
                                dataRows.push({
                                    labels : rowItem.labels,
                                    rep_descripcion : rowItem.rep_descripcion,
                                    datos : datos,
                                    rep_graph : rowItem.rep_graph,
                                    titleData : titleData
                                })                             
                            });
                        break;
                    }
                } else {
                    console.log(json)
                    TOAST_MESSAGE.set(json);
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
            }) //print data to console
            .catch((err) => console.log("Request Failed", err)); // Catch errors
    };

</script>

<div class="container mt-5 text-center">
    <h1>Reportes Favoritos</h1>
    {#if dataRows}
        {#if dataRows.length == 1}
            <div class="row">
                <div class="col-sm-12 col-md-4 offset-md-4">
                    {#each dataRows as item, i}
                        {#if item.rep_graph === "Bar"}
                            <Bars
                                title={item.rep_descripcion}
                                data={item.datos}
                                labels={item.labels }
                                titleData={titleData}
                            />
                        {:else}
                            <Pie
                                title={item.rep_descripcion}
                                data={item.datos[0]}
                                labels={item.labels }
                                titleData={titleData}
                            />
                        {/if}
                    {/each}
                </div>
            </div>
        {:else if dataRows.length >= 2}
            <div class="row">
                {#each dataRows as item, i}
                    <div class="col-sm-12 col-md-6">
                        {#if item.rep_graph === "Bar"}
                            <Bars
                                title={item.rep_descripcion}
                                data={item.datos}
                                labels={item.labels }
                                titleData={titleData}
                            />
                        {:else}
                            <Pie
                                title={item.rep_descripcion}
                                data={item.datos[0]}
                                labels={item.labels }
                                titleData={titleData}
                            />
                        {/if}
                    </div>
                {/each}
            </div>
        {/if}
    {:else}
        <h4>No tienes favoritos</h4>
    {/if}
</div>
